export default __webpack_public_path__ + "static/media/Pickpocket's Bracers of the Tenth Court.376ebfb0.jpg";